import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

// 👇 Global handler for failed lazy-loaded chunks (e.g., after idle or redeploy)
window.addEventListener('unhandledrejection', (event: any) => {
  const msg = event?.reason?.message || '';

  if (
    msg.includes('Failed to fetch dynamically imported module') ||
    msg.includes('Loading chunk') ||
    msg.includes('ChunkLoadError')
  ) {
    if (!sessionStorage.getItem('chunk_reload')) {
      sessionStorage.setItem('chunk_reload', 'true');
      location.reload();
    }
  }
});

bootstrapApplication(AppComponent, appConfig).catch((err) => {
  sessionStorage.removeItem('hasReloaded');
  console.error(err);
});
